import React from 'react';
import { RotateCcw } from 'lucide-react';
import type { TemplateOverrides } from './types';
import { TEMPLATE_OVERRIDE_ALLOWED_TOKENS } from './config';

interface SubjectBodyEditorProps {
  notificationType: string;
  overrides: TemplateOverrides;
  defaultSubject?: string | null;
  defaultBody?: string | null;
  disabled?: boolean;
  onChange: (overrides: TemplateOverrides) => void;
}

export function SubjectBodyEditor({
  notificationType,
  overrides,
  defaultSubject,
  defaultBody,
  disabled,
  onChange
}: SubjectBodyEditorProps) {
  const tokens = TEMPLATE_OVERRIDE_ALLOWED_TOKENS[notificationType] || ['loanNumber', 'borrowerName', 'borrowerLastName', 'date', 'reason'];
  const subjectValue = overrides.subject ?? defaultSubject ?? '';
  const bodyValue = overrides.body ?? defaultBody ?? '';

  return (
    <div className="space-y-3">
      <div className="space-y-1.5">
        <div className="en-section-title mb-1 normal-case tracking-normal">
          <span className="en-field-label">Subject</span>
          <button
            type="button"
            className="en-reset-btn"
            data-preserve-disabled
            disabled={disabled || !overrides.subject}
            onClick={() => onChange({ ...overrides, subject: null })}
          >
            <RotateCcw className="h-3.5 w-3.5" />
            Reset
          </button>
        </div>
        <input
          id="template-subject"
          className="en-field"
          value={subjectValue}
          disabled={disabled}
          placeholder="Use template default"
          onChange={(event) => onChange({ ...overrides, subject: event.target.value })}
        />
      </div>
      <div className="space-y-1.5">
        <div className="en-section-title mb-1 normal-case tracking-normal">
          <span className="en-field-label">Body</span>
          <button
            type="button"
            className="en-reset-btn"
            data-preserve-disabled
            disabled={disabled || !overrides.body}
            onClick={() => onChange({ ...overrides, body: null })}
          >
            <RotateCcw className="h-3.5 w-3.5" />
            Reset
          </button>
        </div>
        <textarea
          id="template-body"
          className="en-field en-textarea"
          value={bodyValue}
          disabled={disabled}
          placeholder="Use template default"
          rows={4}
          onChange={(event) => onChange({ ...overrides, body: event.target.value })}
        />
      </div>
      <div className="en-token-row">
        <span>Tokens:</span>
        {tokens.map((token) => (
          <span key={token} className="en-token">{`{{${token}}}`}</span>
        ))}
      </div>
    </div>
  );
}
